import Base64 from "./Base64"

export default class ImageHelper {
    static getFileFromBase64(string64, fileName) {

        const imageContent = atob(string64)
        const buffer = new ArrayBuffer(imageContent.length)
        const view = new Uint8Array(buffer)

        for (let n = 0; n < imageContent.length; n++) {
            view[n] = imageContent.charCodeAt(n)
        }
        const type = 'image/jpeg'
        const blob = new Blob([buffer], {type})
        return new File([blob], fileName, {lastModified: new Date().getTime(), type})
    }

    static createImage(rawBase64) {
        let base64 = new Base64()
        return new Promise((resolve, reject) => {
            var image = new Image()
            let mimeType = base64.detectMimeType(rawBase64)
            let type

            if (mimeType == 'image/jpg') {
                type = 'data:image/png;base64,'
            } else if (mimeType == 'image/png') {
                type = 'data:image /png;base64,'
            } else {
                return reject("Given base64 is not supported image")
            }

            image.src = type + rawBase64
            image.onload = () => resolve(image)
        })
    }

    static getCanvasImageData(image, options = {}) {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const ctx = canvas.getContext("2d")
        ctx.drawImage(image, 0, 0)
        return ctx.getImageData(0, 0, canvas.width, canvas.height, options)
    }

    static buildRgbData(imageData) {
        let imageColorData = imageData.data
        const rgbValues = []
        for (let i = 0; i < imageColorData.length; i += 4) {
            const rgb = {
                r: imageColorData[i],
                g: imageColorData[i + 1],
                b: imageColorData[i + 2],
                a: imageColorData[i + 3],
            }
            rgbValues.push(rgb)
        }
        return rgbValues
    }

    static checkColorIsHomogeneous(imageData, inDetail = true) {
        let imageColorData = imageData.data
        let step = inDetail ? 4 : 16

        let colorOnFirstPixels = {
            r: imageColorData[0],
            g: imageColorData[0 + 1],
            b: imageColorData[0 + 2],
            a: imageColorData[0 + 3],
        }

        for (let i = 0; i < imageColorData.length; i += step) {
            const rgb = {
                r: imageColorData[i],
                g: imageColorData[i + 1],
                b: imageColorData[i + 2],
                a: imageColorData[i + 3]
            }

            if (colorOnFirstPixels.b != rgb.b || colorOnFirstPixels.g != rgb.g ||
                colorOnFirstPixels.r != rgb.r || colorOnFirstPixels.a != rgb.a) {
                console.log("Iteracji " + i / step)
                return false
            }

        }

        return true
    }

}